var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11 20C14.5899 20 17.5 17.0899 17.5 13.5C17.5 9.91015 14.5899 7 11 7C7.41015 7 4.5 9.91015 4.5 13.5C4.5 17.0899 7.41015 20 11 20Z",
    fill: "#FD8E1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20C14.5899 20 17.5 17.0899 17.5 13.5C17.5 9.91015 14.5899 7 11 7C7.41015 7 4.5 9.91015 4.5 13.5C4.5 17.0899 7.41015 20 11 20Z",
    stroke: "#FD8E1F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4258 7.24361C20.3198 6.99172 21.2574 6.93434 22.1755 7.07533C23.0936 7.21632 23.9708 7.55241 24.748 8.06096C25.5252 8.56952 26.1845 9.23873 26.6813 10.0235C27.1781 10.8083 27.501 11.6904 27.6282 12.6105C27.7554 13.5306 27.684 14.4673 27.4187 15.3574C27.1534 16.2475 26.7005 17.0705 26.0903 17.7709C25.4802 18.4712 24.7271 19.0327 23.8817 19.4175C23.0363 19.8022 22.1183 20.0014 21.1895 20.0015",
    stroke: "#FD8E1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 24.6746C3.01517 23.2306 4.36287 22.052 5.92931 21.2384C7.49576 20.4248 9.23497 20.0001 11.0001 20C12.7652 19.9999 14.5045 20.4246 16.071 21.238C17.6375 22.0515 18.9853 23.23 20.0006 24.6739",
    stroke: "#FD8E1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1895 20C22.9548 19.9987 24.6944 20.4228 26.261 21.2364C27.8276 22.05 29.1752 23.2291 30.1895 24.6739",
    stroke: "#FD8E1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersGroup);
export default __webpack_public_path__ + "static/media/users-group.990cb6f01de351b32d8eef3294c14304.svg";
export { ForwardRef as ReactComponent };